module.exports = __webpack_public_path__ + "static/img/注意通风.6517d2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/warnSign/注意通风.png
// module id = rhYi
// module chunks = 1